"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiDialog from "@/components/dialog/UiDialog.vue";
import i18n from "@/lang";
import API from "@ym-framework/api-utils";
let SetPassword = class extends Vue {
  constructor() {
    super(...arguments);
    this.password_form = {
      password: "",
      repeat_password: ""
    };
    this.rules = {
      password: [
        { required: true, message: i18n.t("set_password.message"), trigger: "blur" },
        {
          trigger: "blur",
          validator: (rule, value, callback) => {
            let passwordreg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,24}$/;
            if (!passwordreg.test(value)) {
              callback(new Error(i18n.t("set_password.error_message")));
            } else {
              callback();
            }
          }
        }
      ],
      repeat_password: [
        { required: true, message: i18n.t("set_password.repeat_password"), trigger: "blur" },
        {
          trigger: "blur",
          validator: (rule, value, callback) => {
            if (value !== this.password_form.password) {
              callback(new Error(i18n.t("set_password.repeat_error_message")));
            } else {
              callback();
            }
          }
        }
      ]
    };
  }
  open() {
    this._set_password_dialog.show();
  }
  resetForm() {
    this.password_form.password = "";
    this.password_form.repeat_password = "";
  }
  submitPassword() {
    this.formSubmit();
  }
  formSubmit() {
    return __async(this, null, function* () {
      try {
        yield this._password_form.validate();
        console.log(this.password_form);
        yield API.post(`api://base.auth/api/v8/accounts/password`, {
          "password": this.password_form.password
        });
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
};
__decorateClass([
  Ref("set-password-dialog")
], SetPassword.prototype, "_set_password_dialog", 2);
__decorateClass([
  Ref("password-form")
], SetPassword.prototype, "_password_form", 2);
SetPassword = __decorateClass([
  Component({
    components: {
      UiDialog
    }
  })
], SetPassword);
export {
  SetPassword as default
};
